export default {
  nome: {
    value: null,
    maxlength: '70',
    required: true,
    state: null
  },
  caixaPasta: {
    value: null,
    maxlength: '50',
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/archiveDocumentsManagement/components/AddFolder/AddFolderForm.js